/***** Begin Shared Scripts *****/



function ShowResultsWindow(results)
{
  resultsWindow = window.open('', 'resultsWindow', 'status=1,resizable=1,scrollbars=1,width=500,height=500');
  resultsWindow.document.write(results);
  resultsWindow.document.close();
}

function TrimAll(sString)
{
  while (sString.substring(0, 1) == ' ')
  {
    sString = sString.substring(1, sString.length);
  }

  while (sString.substring(sString.length - 1, sString.length) == ' ')
  {
    sString = sString.substring(0, sString.length - 1);
  }

  return sString;
}

function SetTextSize(val)
{
}

function ReadTextSizeFromCookie()
{
}

/***** End Shared Scripts *****/


var userId = getUserIdCookie("MYA.1050", { decode: true });

if (userId !== null)
{
    if (document.getElementById("saveUserIdIconTopNav") !== null)
    {
        document.getElementById("saveUserIdIconTopNav").checked = true;
        document.getElementById("usernameIconTopNav").value = userId;
    }

    if (document.getElementById("saveUserIdHeroBanner") !== null)
    {
        document.getElementById("saveUserIdHeroBanner").checked = true;
        document.getElementById("usernameHeroBanner").value = userId;
    }
}



/***** Begin Header Scripts *****/

function ToggleCustomerLoginBox(id)
{
  var e = document.getElementById(id);
  var customerLogin = document.getElementById("customerLogin");
  var customerLoginLink = document.getElementById("notLoggedIn");

  if (e.className == 'CustomerLoginBoxHeaderShow')
  {
    e.className = "CustomerLoginBoxHeaderHide";
    customerLogin.className = "CustomerLogInHide";
    customerLoginLink.className = "";
  }
  else
  {
    e.className = "CustomerLoginBoxHeaderShow";
    customerLogin.className = "CustomerLogInShow";
    customerLoginLink.className = "NotLoggedIn";
  }
}

function ChangeUserNameTextHead(mode, element, prompt)
{
  if (mode == 'focus')
  {
    element.value = '';
  }
  else
  {
    if (element.value == '')
    {
      element.value = prompt;
    }
  }
}

function ChangePasswordTextHead(mode)
{
  if (mode == 'focus')
  {
    document.getElementById('passtempheaddiv').style.display = 'none';
    document.getElementById('passwordheaddiv').style.display = '';
    document.getElementById('passwordhead').value = '';
    document.getElementById('passwordhead').focus();
  }
  else
  {
    if (document.getElementById('passwordhead').value == '')
    {
      document.getElementById('passtempheaddiv').style.display = '';
      document.getElementById('passwordheaddiv').style.display = 'none';
    }
  }
}

/***** End Header Scripts *****/

/***** Begin Top Navigation Scripts *****/

function TopNavItemOn(elementID)
{
  var menuElement = document.getElementById(elementID);
  if (!menuElement.className.match("On"))
  {
    menuElement.className = menuElement.className + "On";
  }
}

function TopNavItemOff(elementID, selectedID)
{
  if (elementID != selectedID)
  {
    var menuElement = document.getElementById(elementID);
    menuElement.className = menuElement.className.replace("On", "");
  }
}

function TopNavMouseHover(elementID, defaultID)
{
  if (defaultID != "")
  {
    var defaultElement = document.getElementById(defaultID);
    defaultElement.className = "NavOff";
  }

  var listElement = document.getElementById(elementID);
  listElement.className = "NavOn";
}

function TopNavMouseOut(elementID, defaultID)
{
  var listElement = document.getElementById(elementID);
  listElement.className = "NavOff";

  if (defaultID != "")
  {
    var defaultElement = document.getElementById(defaultID);
    defaultElement.className = "NavOn";
  }
}

/***** End Top Navigation Scripts *****/


/***** Begin MyAccount Login Scripts *****/

var MyAccountLogin = {};//new Object();
var HeroBanner = {};//new Object();

function LoginKeyPress(source, evt)
{
  if (window.event)
  {
    skeyCode = event.keyCode;
  }
  else
  {
    skeyCode = evt.which;
  }

  if (skeyCode == 13)
  {
    if (source == "Head")
    {
      var headButton = document.getElementById("LoginBtnHead");

      if (headButton)
      {
        headButton.click();
      }
    }
    else if (source == "Quote")
    {
      var quoteButton = document.getElementById(QuoteBox.imgBtnCustomerLoginQuote);

      if (quoteButton)
      {
        quoteButton.click();
      }
    }
    else if (source == "IconTopNav")
    {
      var IconTopNavButton = document.getElementById("LoginBtnIconTopNav");

      if (IconTopNavButton)
      {
        IconTopNavButton.click();
      }
    }
    else if (source == "HeroBanner")
    {
      var HeroBannerLoginButton = document.getElementById("LoginknownCustomer");

      if (HeroBannerLoginButton)
      {
        HeroBannerLoginButton.click();
      }
    }

    return false;
  }
}

function SubmitLoginRequest(source)
{
  if (source == "Head")
  {
    if (document.getElementById("usernamehead").value != "Enter User ID Here" && document.getElementById("passwordhead").value != "")
    {
      SubmitLogin(source, document.getElementById("usernamehead").value, document.getElementById("passwordhead").value);
    }
  }
  else if (source == "IconTopNav")
  {
    if (document.getElementById("usernameIconTopNav").value != "Username" && document.getElementById("passwordIconTopNav").value != "")
    {
      SubmitLogin(source, document.getElementById("usernameIconTopNav").value, document.getElementById("passwordIconTopNav").value, document.getElementById("saveUserIdIconTopNav").checked);
    }
  }
  else if (source == "HeroBanner")
  {
    if (document.getElementById("usernameHeroBanner").value != "Username" && document.getElementById("passwordHeroBanner").value != "")
    {
      SubmitLogin(source, document.getElementById("usernameHeroBanner").value, document.getElementById("passwordHeroBanner").value, document.getElementById("saveUserIdHeroBanner").checked);
    }
  }
  else
  {
    if ((typeof (QuoteBox) != "undefined") && document.getElementById(QuoteBox.txtUserNameQuote).value != QuoteBox.userNameBoxText && document.getElementById(QuoteBox.txtPasswordQuote).value != "")
    {
      SubmitLogin(source, document.getElementById(QuoteBox.txtUserNameQuote).value, document.getElementById(QuoteBox.txtPasswordQuote).value);
    }
    else
    {
      document.getElementById(QuoteBox.lblErrorIDPassword).style.visibility = 'visible';

      return false;
    }
  }
}

function SubmitLogin(source, username, password, saveUserId)
{
  var urlMyAccount = Global.urlMyAccount;
  var urlMyAccountLogin = Global.urlMyAccountLogin;
  var urlMyAccountLoginError = Global.urlMyAccountLoginError;
  var originName = "&origin=allstate.com";

  if ((urlMyAccount === undefined) || (urlMyAccount === ''))
  {
    urlMyAccount = 'https://myaccountrwd.allstate.com';
  }

  if ((urlMyAccountLogin === undefined) || (urlMyAccountLogin === ''))
  {
    urlMyAccountLogin = 'https://myaccountrwd.allstate.com/api/anon/Authentication/login';
    //urlMyAccountLogin = 'https://myaccountrwd.allstate.com/pkmslogin.form';
  }

  if ((urlMyAccountLoginError === undefined) || (urlMyAccountLoginError === ''))
  {
    urlMyAccountLoginError = 'https://myaccountrwd.allstate.com/anon/account/login?invalidLogin=true';
  }

    try {
        if (source == "Head") {
            ProcessMetrics('LoginHead');
        }
        else if (source == "IconTopNav") {
            urlMyAccount = urlMyAccount + '/secured/home?intcid=' + Global.SCPageName + '|MainNav|Login' + originName;
            ProcessMetrics('LoginIconTopNav');
        }
        else if (source == "HeroBanner") {
            urlMyAccount = urlMyAccount + '/secured/home?intcid=' + Global.SCPageName + '|hero|Login' + originName;
            ProcessMetrics('LoginknownCustomer');
        }
        else {
            ProcessMetrics('Login');
        }
    } catch(ex) { }

    if (source != "Head")
    {
        if ((typeof (QuoteBox) != "undefined") && (QuoteBox.lblErrorIDPassword != undefined) && (document.getElementById(QuoteBox.lblErrorIDPassword) != undefined))
        {
            document.getElementById(QuoteBox.lblErrorIDPassword).style.visibility = 'hidden';
        }
    }

  //$.ajax({
  //  type: 'POST',
  //  url: urlMyAccountLogin,
  //  data: encodeURI('username=' + username + '&password=' + password + '&login-form-type=pwd&login=LOGIN'),
  //  xhrFields: {
  //    withCredentials: true
  //  },
  //  success: function(data, config, xhr)
  //  {
  //    if (xhr.getResponseHeader("tam-error-code") != null)
  //    {
  //      var tamErrorCode = xhr.getResponseHeader("tam-error-code");

  //      if (tamErrorCode == '0x132120ef' || tamErrorCode == '0x132120c8')
  //      {
  //        window.location = urlMyAccountLoginError;
  //      }
  //      else
  //      {
  //        window.location = urlMyAccount;
  //      }
  //    }
  //    else
  //    {
  //      window.location = urlMyAccount;
  //    }
  //  }
  //});

  // Old login code

  $.ajax({
    type: 'POST',
    url: urlMyAccountLogin,
    data: JSON.stringify({ userName: username, password: password }),
    contentType: 'application/json',
    dataType: 'json',
    timeout:10000,
    xhrFields: {	
         withCredentials: true	
    },    
    success: function (data)
    {
      if (data.loginStatus === 'Success')
      {
        AddMyAccountCookies(saveUserId, username, data.webSealCookieCollection);
        window.location = urlMyAccount;
      }
      else
      {
        if (data.errors.length > 0)
        {
          window.location = urlMyAccountLoginError;
        }
      }
    },
    error: function (request, status, error)
    {
      window.location = urlMyAccountLoginError;
    }
  });
}

function SubmitLogout()
{
  var input = { 'cookies': JSON.stringify(document.cookie) };
  
  var urlMyAccountLogout = Global.urlMyAccountLogout;

  if ((urlMyAccountLogout === undefined) || (urlMyAccountLogout === ''))
  {
    urlMyAccountLogout = 'https://myaccountrwd.allstate.com/api/anon/Authentication/logout';
    //urlMyAccountLogout = 'https://myaccountrwd.allstate.com/pkmslogout.form';
  }

  //$.ajax({
  //  type: 'POST',
  //  url: urlMyAccountLogout,
  //  data: null,

  //  success: function (data)
  //  {
  //  }
  //});

  // Old logout code

  $.ajax({
    type: 'POST',
    url: urlMyAccountLogout,
    data: JSON.stringify(input),
    contentType: 'application/json',
    dataType: 'json',

    success: function (data)
    {
      DeleteMyAccountCookies();
    }
  });
}

function AddMyAccountCookies(saveUserId, username, cookies)
{
  if (!saveUserId)
  {
    username = undefined;
  }

  setUserIdCookie("MYA.1050", username,
  {
    expires: "01 Jan 2030",
    encode: true,
    domain: ".allstate.com"
  });

  if ((cookies != null) && (cookies.length > 0))
  {
    var cookie;

    for (var i = 0; i < cookies.length; i++)
    {
      if (!!cookies[i].name && !!cookies[i].value && !!cookies[i].domain)
      {
        cookie = cookies[i].name + '=' + cookies[i].value + ';domain=' + cookies[i].domain + ';path=/;secure';
        document.cookie = cookie;
      }
      else if (!!cookies[i].name && !!cookies[i].value)
      {
        cookie = cookies[i].name + '=' + cookies[i].value + ';path=/;secure';
        document.cookie = cookie;
      }
    }
  }
}

function DeleteMyAccountCookies()
{
  document.cookie.split(";").forEach(function (c)
  {
    if (c.indexOf("SESSION-ID") > -1)
    {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    }
  });

  var unauthenticatedUser = { isAuthenticated: false, isBlacklisted: false, isDisabled: false, isUpgradeAccount: false, isVerifyRequired: false };
  document.cookie = ["myaUser", '=', JSON.stringify(unauthenticatedUser), '; domain=.allstate.com', ';path=/;secure'].join('');
}

function CheckCookies()
{
  document.cookie = "CheckCookies=Yes; path=/";

  if (urlMyAccountLogOn == "")
  {
    urlMyAccountLogOn = "https://myaccount.allstate.com/Anon/Handlers/ExternalLoginHandler.ashx?";
  }

  if (document.cookie.indexOf("CheckCookies=Yes") != -1)
  {
    var exp = new Date();
    exp.setTime(exp.getTime() - 100);
    document.cookie = "CheckCookies=Yes; path=/; expires=" + exp.toGMTString();

    document.forms[0].action = urlMyAccountLogOn + "CookiesEnabled=Yes";
  }
  else
  {
    document.forms[0].action = urlMyAccountLogOn + "CookiesEnabled=No";
  }
}

function getUserIdCookie(cName, options)
{
  var cVal = document.cookie.match('(?:^|;) ?' + cName + '=([^;]*)(?:;|$)');

  if (!cVal)
  {
    return null;
  }
  else
  {
    var value = cVal[1];
    options = options || {};

    if (options.decode)
    {
      value = window.atob(value);
    }

    return value;
  }
}

function setUserIdCookie(name, value, options)
{
  var path, expires, encode;

  options = options || {};
  expires = options.expires;
  encode = options.encode
  path = "/";

  if (value === undefined)
  {
    expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    value = '';
  }

  expires = new Date(expires);

  if (encode)
  {
    value = window.btoa(encodeURIComponent(value));
  }
  else
  {
    value = encodeURIComponent(value);
  }

  var str = encodeURIComponent(name) + '=' + value;
  str += path ? ';path=' + path : '';
  str += options.domain ? ';domain=' + options.domain : '';
  str += expires ? ';expires=' + expires.toUTCString() : '';
  str += options.secure ? ';secure' : '';

  // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
  // - 300 cookies
  // - 20 cookies per unique domain
  // - 4096 bytes per cookie
  var cookieLength = str.length + 1;

  if (cookieLength > 4096)
  {
    return;
  }

  document.cookie = str;
}

/***** End MyAccount Login Scripts *****/


/***** Begin Refer a Friend Scripts *****/

var ReferAFriend = {};//new Object();

ReferAFriend.scAccount = '';
ReferAFriend.scDestination = '';
ReferAFriend.scDescription = '';
ReferAFriend.scDomainSource = '';
ReferAFriend.scType = '';
ReferAFriend.scAgentID = '';
ReferAFriend.scState = '';
ReferAFriend.scTerritoryCode = '';
ReferAFriend.scTerritoryManagerCode = '';
ReferAFriend.scAgentType = '';
ReferAFriend.scPFRIndicator = '';
ReferAFriend.updPnlProspectsID = '';



ReferAFriend.AddProspect = function ()
{
  __doPostBack(ReferAFriend.updPnlProspectsID, "customPostback");
}

ReferAFriend.SubmitReferrals = function ()
{
  if (Page_ClientValidate() == false)
  {
    document.getElementById('lblErrorMessage').style.display = 'block';
  }

  for (var i = 0; i < Page_Validators.length; i++)
  {
    var val = Page_Validators[i];
    var ctrl = document.getElementById(val.controltovalidate);

    if ((ctrl != null) && (ctrl.style != null) && ((val.id.indexOf("rfv") >= 0) || (val.id.indexOf("rev") >= 0)))
    {
      if (!val.isvalid)
      {
        ctrl.className = ctrl.className + ' Error';
      }
      else if ((val.id.indexOf("rfv") >= 0) || ((val.id.indexOf("rev") >= 0) && (document.getElementById(val.controltovalidate).textLength > 0)))
      {
        if (ctrl.className.indexOf(' ') >= 0)
        {
          ctrl.className = ctrl.className.substring(0, ctrl.className.indexOf(' '));
        }
      }
    }
  }

  if (Page_ClientValidate() == true)
  {
    try{
        ProcessMetrics('ReferAFriend', [ReferAFriend.scAccount, ReferAFriend.scDestination, ReferAFriend.scType, ReferAFriend.scDescription, ReferAFriend.scDomainSource, ReferAFriend.scAgentID, ReferAFriend.scState, ReferAFriend.scTerritoryCode, ReferAFriend.scTerritoryManagerCode, ReferAFriend.scAgentType, ReferAFriend.scPFRIndicator]);
    } catch (ex) { }    
  }
}

/***** End Refer a Friend Scripts *****/




/***** Start Free Text Scroller Component  *****/
//function FreeTextScrollerRotate(scroller, direction)
//{
//  var panels = GetFreeTextScrollerMenuPanels(scroller);
//  var navigationleft = GetFreeTextScrollerMenu(scroller, 'left');
//  var navigationright = GetFreeTextScrollerMenu(scroller, 'right');;

//  // create paging image array;
//  var images = GetFreeTextScrollerNavigationImages(scroller);
//  var scrollerpager = FreeTextScrollerFindChildElement(GetFreeTextScroller(scroller, 'DIV', 'FreeTextScroller'), 'DIV', 'ScrollerPage');
//  //for (j = 0, jj = scrollerpager.childNodes.length; j < jj; j++) {
//  //    if (scrollerpager.childNodes[j].nodeName == 'DIV') images.push(scrollerpager.childNodes[j]);
//  //}
//  // find current panel
//  for (i = 0; i < panels.length; i++)
//  {
//    if (panels[i].getAttribute('class') == 'PanelVisible')
//    {
//      break;
//    }
//  }


//  if (i == 0 && direction == 'left') FreeTextScrollerEnable(scroller, panels.length);
//  else if (i == (panels.length - 1) && direction == 'right') FreeTextScrollerEnable(scroller, 1);
//  else
//  {


//    if (i > 0 && direction == 'left')
//    {
//      panels[i - 1].setAttribute('class', 'PanelVisible');
//      images[i - 1].setAttribute('class', 'ScrollerPageImageOn');
//    }
//    else if (i < panels.length && direction == 'right')
//    {
//      panels[i + 1].setAttribute('class', 'PanelVisible');
//      images[i + 1].setAttribute('class', 'ScrollerPageImageOn');
//    }
//    // set previously visible element to image off
//    panels[i].setAttribute('class', 'PanelHidden');
//    images[i].setAttribute('class', 'ScrollerPageImageOff');
//  }



//  // reset left right nav based on current position
//  InitFreeTextScrollerMenu(GetFreeTextScroller(scroller, 'DIV', 'FreeTextScroller'));
//}

//function FreeTextScrollerGo(scroller, panelNum)
//{
//  var panels = GetFreeTextScrollerMenuPanels(scroller);
//  var images = GetFreeTextScrollerNavigationImages(scroller);

//  for (i = 0; i < panels.length; i++)
//  {
//    if (i == panelNum)
//    {
//      panels[i].setAttribute('class', 'PanelVisible');
//      images[i].setAttribute('class', 'ScrollerPageImageOn');
//    }
//    else
//    {
//      panels[i].setAttribute('class', 'PanelHidden');
//      images[i].setAttribute('class', 'ScrollerPageImageOff');
//    }
//  }
//}

//function FreeTextScrollerEnable(scroller, panel)
//{
//  panel--;  // offset
//  var panels = GetFreeTextScrollerMenuPanels(scroller);
//  var images = GetFreeTextScrollerNavigationImages(scroller);

//  for (var i = 0; i < panels.length; i++)
//  {
//    panels[i].setAttribute('class', 'PanelHidden');
//  }
//  panels[panel].setAttribute('class', 'PanelVisible');

//  for (var j = 0; j < images.length; j++)
//  {
//    images[j].setAttribute('class', 'ScrollerPageImageOff');
//  }
//  images[panel].setAttribute('class', 'ScrollerPageImageOn');
//}



//// Function initiates menu based on which panel is currently visible.
//// ie. if 1st panel is visible, show only right navigation switch.
////     if n-1 panel is visible, show botwh navigation switches.
//// parameters:  scroller - control which is making the call
//function InitFreeTextScrollerMenu(scroller)
//{
//  var panels = GetFreeTextScrollerMenuPanels(scroller);

//  // find currently open panel
//  for (var i = 0; i < panels.length; i++)
//  {
//    if (panels[i].getAttribute('class') == 'PanelVisible') break;
//  }
//  var navigationleft = GetFreeTextScrollerMenu(scroller, 'left');
//  var navigationright = GetFreeTextScrollerMenu(scroller, 'right');
//  switch (i)
//  {
//    case 0:
//      navigationleft.setAttribute('class', 'golefthidden');
//      navigationright.setAttribute('class', 'goright');
//      break;
//    case panels.length - 1:
//      navigationleft.setAttribute('class', 'goleft');
//      navigationright.setAttribute('class', 'gorighthidden');
//      break;
//    default:
//      navigationleft.setAttribute('class', 'goleft');
//      navigationright.setAttribute('class', 'goright');
//      break;

//  }

//}

//// Function hides navigation switches
//// parameters:  scroller - control which is making the call
//function HideFreeTextScrollerMenu(scroller)
//{
//  GetFreeTextScrollerMenu(scroller, 'left').setAttribute('class', 'golefthidden');
//  GetFreeTextScrollerMenu(scroller, 'right').setAttribute('class', 'gorighthidden');
//}


//// supporting functions
//// parameters:  scroller - control which is making the call
//function GetFreeTextScrollerMenuPanels(scroller)
//{
//  scroller = FreeTextScrollerFindChildElement(GetFreeTextScroller(scroller, 'DIV', 'FreeTextScroller'), 'DIV', 'FreeTextScrollerPanels');
//  var panels = new Array();
//  for (var i = 0; i < scroller.childNodes.length; i++)
//  {
//    if (scroller.childNodes[i].nodeName == 'DIV'
//                    && (scroller.childNodes[i].getAttribute('class') == 'PanelVisible'
//                        || scroller.childNodes[i].getAttribute('class') == 'PanelHidden'))
//      panels.push(scroller.childNodes[i]);
//  }
//  return panels;
//}

//// parameters:  scroller - control which is making the call
//function GetFreeTextScrollerNavigationImages(scroller)
//{
//  scroller = FreeTextScrollerFindChildElement(GetFreeTextScroller(scroller, 'DIV', 'FreeTextScroller'), 'DIV', 'ScrollerPage');
//  var Images = new Array();
//  for (var i = 0; i < scroller.childNodes.length; i++)
//  {
//    if (scroller.childNodes[i].nodeName == 'A'
//                    && (scroller.childNodes[i].getAttribute('class') == 'ScrollerPageImageOff'
//                        || scroller.childNodes[i].getAttribute('class') == 'ScrollerPageImageOn'))
//    {
//      Images.push(scroller.childNodes[i]);
//    }
//  }

//  return Images;
//}

//// function returns child element within source element which matches elementname and targetclass
//// ex.  FreeTextScrollerFindChildElement(this, 'DIV', 'goleft');
//function FreeTextScrollerFindChildElement(source, elementname, targetclass)
//{
//  //var undefined;
//  if (typeof (source) == undefined) return null;

//  if (source.nodeName == elementname && source.getAttribute('class') == targetclass)
//    return source;

//  for (var k = 0, kk = source.childNodes.length; k < kk; k++)
//  {
//    // skip if whitespace
//    if (source.childNodes[k].nodeName == '#text') continue;

//    // scan current child
//    var child = FreeTextScrollerFindChildElement(source.childNodes[k], elementname, targetclass);

//    // check if child is null,  if it is, function hit dead end, continue with next child else return found child.
//    if (child == null) continue;
//    else return child;
//  }
//  // if function runs out of childred without finding target, return null
//  return null;
//}



//// Function finds which switch was pushed and returns the switch as an object
//// parameters:  scroller - control which is making the call
////              direction - string containing 'left' or 'right' direction of the scroll
//function GetFreeTextScrollerMenu(scroller, direction)
//{
//  var navigationleft = null;
//  var navigationright = null;
//  navigation = FreeTextScrollerFindChildElement(GetFreeTextScroller(scroller, 'DIV', 'FreeTextScroller')
//        , 'DIV',
//        'Navigation');

//  for (var i = 0; i < navigation.childNodes.length; i++)
//  {
//    if (navigation.childNodes[i].nodeName == 'DIV'
//                    && (navigation.childNodes[i].getAttribute('class') == 'goleft'
//                    || navigation.childNodes[i].getAttribute('class') == 'golefthidden'
//                    ))
//    {
//      navigationleft = navigation.childNodes[i];

//    }
//    if (navigation.childNodes[i].nodeName == 'DIV'
//                    && (navigation.childNodes[i].getAttribute('class') == 'goright'
//                    || navigation.childNodes[i].getAttribute('class') == 'gorighthidden'
//                    ))
//    {
//      navigationright = navigation.childNodes[i];
//    }
//  }
//  if (direction == 'left')
//  {
//    return navigationleft;
//  }
//  else
//  {
//    return navigationright;
//  }
//}

//// function returns parent element of THIS object that meets elementname and targetclass
//// ex.  GetFreeTextScroller(this, 'DIV', 'control_container');
//function GetFreeTextScroller(source, elementname, targetclass)
//{
//  // verify current object and its parent

//  //var undefined;  // declare undefined element
//  if (typeof (source) == undefined) return null;

//  // if parent matches return it, else use recursion to find next parent
//  if (source.nodeName == elementname && source.getAttribute('class') == targetclass)
//    return source;
//  else
//    return GetFreeTextScroller(source.parentNode, elementname, targetclass);
//}

//function FreeTextScrollerPointerOn(source)
//{
//  source.style.cursor = 'pointer';
//}

//function FreeTextScrollerPointerOff(source)
//{
//  source.style.cursor = 'default';
//}

//var freeTextScrollerArr;




//function FreeTextScrollerInit()
//{
//  try
//  {
//    var divs = document.getElementsByTagName('DIV');
//    FreeTextScrollers = new Array();
//    for (var i = 0, ii = divs.length; i < ii; i++)
//    {
//      //alert(divs[i].getAttribute('class'));
//      if (divs[i].getAttribute('class') == 'FreeTextScroller') FreeTextScrollers.push(divs[i]);
//    }

//    for (i = 0, ii = FreeTextScrollers.length; i < ii; i++)
//    {
//      // Setup page location images
//      var scrScrollerPage = FreeTextScrollerFindChildElement(FreeTextScrollers[i], 'DIV', 'ScrollerPage');
//      var pagecount = GetFreeTextScrollerMenuPanels(FreeTextScrollers[i]).length;
//      var offset = (FreeTextScrollers[i].offsetWidth - (pagecount * 15 + 7)) / 2
//      scrScrollerPage.setAttribute('style', 'margin-left:' + offset + 'px');
//      var scrFooter = FreeTextScrollerFindChildElement(FreeTextScrollers[i], 'DIV', 'Footer');
//      var scrHeader = FreeTextScrollerFindChildElement(FreeTextScrollers[i], 'DIV', 'Header');
//      var scrScrollerPanel = FreeTextScrollerFindChildElement(FreeTextScrollers[i], 'DIV', 'FreeTextScrollerPanels');
//      var currentScroller = FreeTextScrollers[i];
//      var panels = GetFreeTextScrollerMenuPanels(currentScroller);

//      var maxpanelheight = 0;
//      for (j = 0; j < panels.length; j++)
//      {
//        panels[j].setAttribute('class', 'PanelVisible');
//        maxpanelheight = panels[j].offsetHeight > maxpanelheight ? panels[j].offsetHeight : maxpanelheight;
//        panels[j].setAttribute('class', 'PanelHidden');
//      }
//      for (j = 0; j < panels.length; j++)
//      {
//        panels[j].setAttribute('style', 'height:' + maxpanelheight + 'px');
//      }

//      panels[0].setAttribute('class', 'PanelVisible');

//      var scrNavigation = FreeTextScrollerFindChildElement(FreeTextScrollers[i], 'DIV', 'Navigation');
//      scrNavigation.setAttribute('style', 'top:' + ((FreeTextScrollers[i].offsetHeight / 2) - 5) + 'px');
//    }
//  }
//  catch (ex)
//  {


//    /* do nothing */
//  }

//}
/***** End Free Text Scroller Component  *****/ 



/***** Begin HTML Rotating Banner Component  *****/

/***************************************************************************************************
Description: Javascript for HTML Rotating Banner component.

Public Functions:
HtmlRotatingBanner.initialize      - Must be called to initialize the rotater with appropriate parameters.
HtmlRotatingBanner.pause           - Pauses the playing of the banner.
HtmlRotatingBanner.play            - Begins the auto rotating of the banners.
HtmlRotatingBanner.rotateLeft      - Rotates to the left one banner.
HtmlRotatingBanner.rotateRight     - Rotates to the right one banner.

Author: Jeff Bonifaci

Created: 2012-03-23

****************************************************************************************************
Change History
****************************************************************************************************
Date       Who           Description
---------- ------------- --------------------------------------------------------------------------
2012-03-23 Jeff Bonifaci Initial Creation.
****************************************************************************************************



****************************************************************************************************
Define Public Global Variables.
HtmlRotatingBanner - Object used to interact with all Html Rotating Banner functionality.
***************************************************************************************************/
var HtmlRotatingBanner = {};//new Object();



/***************************************************************************************************
Define Private Global Variables.
HtmlRotatingBanner._AutoRotate                   - Boolean indicating if auto rotation is currently on.
HtmlRotatingBanner._BannerElementIdBasename      - Base name of the id for each banner element.
HtmlRotatingBanner._CurrentBanner                - Current banner being displayed.
HtmlRotatingBanner._CurrentBannerNumberElementId - Id of Element to use to display current banner number.
HtmlRotatingBanner._RotateIntervalSeconds        - Total number of seconds to wait between each rotation.
HtmlRotatingBanner._TotalBanners                 - Total number of banners.
HtmlRotatingBanner._TotalBannersNumberElementId  - Id of Element to use to display total banners number.
***************************************************************************************************/
HtmlRotatingBanner._AutoRotate = false;
HtmlRotatingBanner._BannerElementIdBasename = '';
HtmlRotatingBanner._CurrentBanner = 0;
HtmlRotatingBanner._CurrentBannerNumberElementId = '';
HtmlRotatingBanner._TotalBanners = 0;
HtmlRotatingBanner._TotalBannersNumberElementId = '';
HtmlRotatingBanner._RotateIntervalSeconds = 0;



/***************************************************************************************************
Begin Public Functions.
HtmlRotatingBanner.initialize
HtmlRotatingBanner.pause
HtmlRotatingBanner.play
HtmlRotatingBanner.rotateLeft
HtmlRotatingBanner.rotateRight
***************************************************************************************************/



/***************************************************************************************************
Function: HtmlRotatingBanner.initialize
Description: Initializes the html rotating banner based on the passed in parameters.
Parameters:
bannerElementBaseName        - Base name of the id for each banner element.
currentBanner                - First/current banner to display.
currentBannerNumberElementId - Id of Element to use to display current banner number.
totalBanners                 - Total number of banners.
totalBannersNumberElementId  - Id of Element to use to display total banners number.
rotateIntervalSeconds        - Total number of seconds to wait between each rotation.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner.initialize = function (bannerElementBaseName, currentBanner, currentBannerNumberElementId, totalBanners, totalBannersNumberElementId, rotateIntervalSeconds)
{
  // Store the passed in parameters to their respective global private variables.
  HtmlRotatingBanner._BannerElementIdBasename = bannerElementBaseName;
  HtmlRotatingBanner._CurrentBannerNumberElementId = currentBannerNumberElementId
  HtmlRotatingBanner._TotalBannersNumberElementId = totalBannersNumberElementId
  HtmlRotatingBanner._RotateIntervalSeconds = rotateIntervalSeconds;
  HtmlRotatingBanner._setCurrentBannerNumber(currentBanner);
  HtmlRotatingBanner._setTotalBannersNumber(totalBanners);

  // Show the current banner.
  HtmlRotatingBanner._showBanner(HtmlRotatingBanner._CurrentBanner);
} //HtmlRotatingBanner.initialize()



/***************************************************************************************************
Function: HtmlRotatingBanner.pause
Description: Pauses the automated banner rotation.
Parameters:
None.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner.pause = function ()
{
  // Set auto rotate to false.
  HtmlRotatingBanner._AutoRotate = false;
} //HtmlRotatingBanner.pause()



/***************************************************************************************************
Function: HtmlRotatingBanner.play
Description: Begins the automated banner rotation.
Parameters:
None.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner.play = function ()
{
  // Set auto rotate to true.
  HtmlRotatingBanner._AutoRotate = true;

  // Call auto rotate after the interval has passed.
  setTimeout('HtmlRotatingBanner._autoRotate()', HtmlRotatingBanner._RotateIntervalSeconds * 1000);
} //HtmlRotatingBanner.play()



/***************************************************************************************************
Function: HtmlRotatingBanner.rotateLeft
Description: Rotates left one banner.
Parameters:
autoRotate - Boolean indicating if this was called by the auto rotate function.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner.rotateLeft = function (autoRotate)
{
  // Declare local variables.
  //     newBanner - The new banner to display.
  var newBanner = HtmlRotatingBanner._CurrentBanner - 1;

  // If this function wasn't called by auto rotate, pause the auto rotation.
  if (!autoRotate)
  {
    HtmlRotatingBanner.pause();
  }

  // If the newBanner is less than 1, set it to the last banner.
  if (newBanner < 1)
  {
    newBanner = HtmlRotatingBanner._TotalBanners;
  }

  // Switch banners.
  HtmlRotatingBanner._switchBanner(HtmlRotatingBanner._CurrentBanner, newBanner);
} //HtmlRotatingBanner.rotateLeft()



/***************************************************************************************************
Function: HtmlRotatingBanner.rotateRight
Description: Rotates left one banner.
Parameters:
autoRotate - Boolean indicating if this was called by the auto rotate function.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner.rotateRight = function (autoRotate)
{
  // Declare local variables.
  //     newBanner - The new banner to display.
  var newBanner = HtmlRotatingBanner._CurrentBanner + 1;

  // If this function wasn't called by auto rotate, pause the auto rotation.
  if (!autoRotate)
  {
    HtmlRotatingBanner.pause();
  }

  // If the newBanner is greater than the total banners, set it to the first banner.
  if (newBanner > HtmlRotatingBanner._TotalBanners)
  {
    newBanner = 1;
  }

  // Switch banners.
  HtmlRotatingBanner._switchBanner(HtmlRotatingBanner._CurrentBanner, newBanner);
} //HtmlRotatingBanner.rotateRight()

/***************************************************************************************************
End Public Functions.
***************************************************************************************************/



/***************************************************************************************************
Begin Private Functions.
HtmlRotatingBanner._autoRotate
HtmlRotatingBanner._fadeElement
HtmlRotatingBanner._fadeInBanner
HtmlRotatingBanner._fadeOutBanner
HtmlRotatingBanner._hideBanner
HtmlRotatingBanner._setCurrentBannerNumber
HtmlRotatingBanner._setTotalBannersNumber
HtmlRotatingBanner._showBanner
HtmlRotatingBanner._switchBanner
***************************************************************************************************/



/***************************************************************************************************
Function: HtmlRotatingBanner._autoRotate
Description: Facilitates the automatic rotation of the banner.
Parameters:
None.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._autoRotate = function ()
{
  // If auto rotate is not on, return and do nothing.
  if (!HtmlRotatingBanner._AutoRotate)
  {
    return;
  }

  // Call rotate right.
  HtmlRotatingBanner.rotateRight(true);

  // Call auto rotate again the interval has passed.
  setTimeout('HtmlRotatingBanner._autoRotate()', HtmlRotatingBanner._RotateIntervalSeconds * 1000);
} //HtmlRotatingBanner._autoRotate



/***************************************************************************************************
Function: HtmlRotatingBanner._fadeElement
Description: Fades the element in and sets the class at the end.
Parameters:
fadeElement       - Element to fade.
startOpacityLevel - The level of opacity to start at.
endOpacityLevel   - The level of opacity to end at.
opacityModifier   - The value to modify the opacity by.
startClass        - (optional) The class to set for the element before the fading starts.
endClass          - (optional) The class to set for the element when the fading ends.
nextFunction      - (optional) Function to call when the fading ends.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._fadeElement = function (fadeElement, startOpacityLevel, endOpacityLevel, opacityModifier, startClass, endClass, nextFunction)
{
  // Declare local variables.
  //     elementOpacityLevel - The current level of opacity for the element.
  var elementOpacityLevel = startOpacityLevel;

  // Set the initial element opacity before setting the start class.
  fadeElement.style.opacity = elementOpacityLevel / 100;
  fadeElement.style.filter = "progid:DXImageTransform.Microsoft.Alpha(Opacity=" + elementOpacityLevel + ")";

  // Set the element start class if it is defined.
  if (startClass)
  {
    fadeElement.setAttribute("class", startClass);
  }

  // Build the fade function variable.
  var fadeFunction = function ()
  {
    // Modify the opacity level by the opacity modifier.
    elementOpacityLevel += opacityModifier;

    // Set the element opacity.
    fadeElement.style.opacity = elementOpacityLevel / 100;
    fadeElement.style.filter = "progid:DXImageTransform.Microsoft.Alpha(Opacity=" + elementOpacityLevel + ")";

    // If the opacity level is equal to the end opacity level, end the fading and set the end class.
    if (elementOpacityLevel == endOpacityLevel)
    {
      clearInterval(intervalId);

      if (endClass)
      {
        fadeElement.setAttribute("class", endClass);
      }

      // If there is next function to call, call it.
      if (nextFunction)
      {
        nextFunction();
      }

      return;
    }
  }

  // Call the fadeFunction using setInterval to create the visual fading effect.
  var intervalId = setInterval(fadeFunction, 1);
} //HtmlRotatingBanner._fadeElement()



/***************************************************************************************************
Function: HtmlRotatingBanner._fadeInBanner
Description: Fades the banner element in.
Parameters:
bannerElement - Banner element to fade in.
nextFunction  - (optional) Function to call when the fading ends.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._fadeInBanner = function (bannerElement, nextFunction)
{
  // Call the fade element function the appropriate parameters.
  HtmlRotatingBanner._fadeElement(bannerElement, 0, 100, 10, "selectedBanner", "selectedBanner", nextFunction);
} //HtmlRotatingBanner._fadeInBanner()



/***************************************************************************************************
Function: HtmlRotatingBanner._fadeOutBanner
Description: Fades the banner element out.
Parameters:
bannerElement - Banner element to fade out.
nextFunction  - (optional) Function to call when the fading ends.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._fadeOutBanner = function (bannerElement, nextFunction)
{
  // Call the fade element function the appropriate parameters.
  HtmlRotatingBanner._fadeElement(bannerElement, 100, 0, -5, "selectedBanner", "banner", nextFunction);
} //HtmlRotatingBanner._fadeOutBanner()



/***************************************************************************************************
Function: HtmlRotatingBanner._hideBanner
Description: Hides the banner div corresponding to the id passed in.
Parameters:
bannerId - Id of the banner div to hide.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._hideBanner = function (bannerId)
{
  // Declare local variables.
  //     bannerElement - The banner element for the banner id passed in.
  var bannerElement = document.getElementById(HtmlRotatingBanner._BannerElementIdBasename + bannerId);

  // Fade the banner out.
  HtmlRotatingBanner._fadeOutBanner(bannerElement);
} //HtmlRotatingBanner._hideBanner()



/***************************************************************************************************
Function: HtmlRotatingBanner._setCurrentBannerNumber
Description: Sets the current banner number value and displays it in the corresponding element.
Parameters:
currentBannerNumber - The current banner number.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._setCurrentBannerNumber = function (currentBannerNumber)
{
  // Declare local variables.
  //     currentBannerNumberElement - The banner element for the banner id passed in.
  var currentBannerNumberElement = document.getElementById(HtmlRotatingBanner._CurrentBannerNumberElementId);

  // Set the current banner number.
  HtmlRotatingBanner._CurrentBanner = currentBannerNumber;

  // Display the current banner number in the current banner number element.
  currentBannerNumberElement.innerHTML = HtmlRotatingBanner._CurrentBanner;
} //HtmlRotatingBanner._setCurrentBannerNumber



/***************************************************************************************************
Function: HtmlRotatingBanner._setTotalBannersNumber
Description: Sets the total banners number value and displays it in the corresponding element.
Parameters:
totalBannersNumber - The total banners number.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._setTotalBannersNumber = function (totalBannersNumber)
{
  // Declare local variables.
  //     totalBannersNumberElement - The banner element for the banner id passed in.
  var totalBannersNumberElement = document.getElementById(HtmlRotatingBanner._TotalBannersNumberElementId);

  // Set the total banners number.
  HtmlRotatingBanner._TotalBanners = totalBannersNumber;

  // Display the total banners number in the total banners number element.
  totalBannersNumberElement.innerHTML = HtmlRotatingBanner._TotalBanners;
} //HtmlRotatingBanner._setTotalBannersNumber



/***************************************************************************************************
Function: HtmlRotatingBanner._showBanner
Description: Shows the banner div corresponding to the id passed in.
Parameters:
bannerId - Id of the banner div to show.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._showBanner = function (bannerId)
{
  // Declare local variables.
  //     bannerElement - The banner element for the banner id passed in.
  var bannerElement = document.getElementById(HtmlRotatingBanner._BannerElementIdBasename + bannerId);

  // Fade the banner in.
  HtmlRotatingBanner._fadeInBanner(bannerElement);
} //HtmlRotatingBanner._showBanner()



/***************************************************************************************************
Function: HtmlRotatingBanner._switchBanner
Description: Switches the current banner with the new banner based on ids passed in.
Parameters:
currentBannerId - Id of the current banner div to shown.
newBannerId     - Id of the new banner div to show.
Return value:
None.
***************************************************************************************************/
HtmlRotatingBanner._switchBanner = function (currentBannerId, newBannerId)
{
  // Declare local variables.
  //     currentBannerElement - The current banner element for the banner id passed in.
  //     newBannerElement    - The new banner element for the banner id passed in.
  var currentBannerElement = document.getElementById(HtmlRotatingBanner._BannerElementIdBasename + currentBannerId);
  var newBannerElement = document.getElementById(HtmlRotatingBanner._BannerElementIdBasename + newBannerId);

  // Set the current banner number to the new banner number.
  HtmlRotatingBanner._setCurrentBannerNumber(newBannerId);

  // Create a function object to fade in the new banner to be passed to the fader to call upon completion.
  var fadeInFunction = function () { HtmlRotatingBanner._fadeInBanner(newBannerElement); };

  // Fade the current banner out and the new banner in.
  HtmlRotatingBanner._fadeOutBanner(currentBannerElement, fadeInFunction);
} //HtmlRotatingBanner._showBanner()



/****************************************************************************************************
End Private Functions.
****************************************************************************************************/

/***** End HTML Rotating Banner Component  *****/


/***** Begin Navigation Footer Component Scripts *****/

var NavigationFooter = {};//new Object();

NavigationFooter.setUpPagination = function (carouselId)
{
  $('#' + carouselId + ' .carousel-inner').slick({
    appendDots: $('#' + carouselId + ' .carousel-indicators'),
    autoplay: false,
    autoplaySpeed: 2500,
    dots: true,
    infinite: true,
    nextArrow: $('#' + carouselId + ' .right.carousel-control'),
    prevArrow: $('#' + carouselId + ' .left.carousel-control'),
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500
  });

  if ($('#' + carouselId + ' .carousel-inner .agentInfo').length <= 1)
  {
    $('#' + carouselId + ' .slick-arrow').hide();
  }
}




NavigationFooter.checkAgentImages = function () {
    for (var i = 0; i < $('.agentList').find('img.agentPhoto').length; i++) {
        if (!bsCommon.isImageOk($('.agentList').find('img.agentPhoto')[i])) {
            $($('.agentList').find('img.agentPhoto')[i]).attr('src', '/resources/images/agent-mia.jpg');
        }
    }
}
  


//NavigationFooter.agentCarousel = function (drwNm)
//{
//  /* single width customer version */
//  $('#' + drwNm + ' .agentListing').easyPaginate({
//    step: 1,
//    container: 'agent-nav'
//  });
//}

//NavigationFooter.mobileAgentSwipeSlides = function (dir)
//{
//  switch (dir)
//  {
//    case 'left': $(".slides-outer-navfooter").cycle("next");
//      break;
//    case 'right': $(".slides-outer-navfooter").cycle("prev");
//      break;
//  }
//}

//NavigationFooter.initiateCarouselSwipe = function ()
//{
//  if ($(".NavigationFooter .agentListing").children().length > 0)
//  {
//    var myLeftNavHTML = "<a class='slides_prev-navfooter'>Previous</a>";
//    var myRightNavHTML = "<a class='slides_next-navfooter'>Next</a>";
//    var myBottomNavHTML = "<div class='slides-nav-out-navfooter'><div class='slides-nav-navfooter'></div></div><div class='agent-nav'></div>";
//    $(".NavigationFooter .NFAgentLeft").html(myLeftNavHTML);
//    $(".NavigationFooter .NFAgentRight").html(myRightNavHTML);

//    if ($('.slides-outer-navfooter:visible').length)
//    {
//      // only animate carousel slides if they exist
//      $('.slides-outer-navfooter').cycle('destroy');
//      $('.slides-outer-navfooter').css('height', 'auto');
//      $('.slides-outer-navfooter').cycle({
//        fx: 'scrollHorz',
//        //timeout: timeout,
//        pager: '.slides-nav-navfooter',
//        slideExpr: '.slides-inner-navfooter',
//        next: '.slides_next-navfooter',
//        prev: '.slides_prev-navfooter',
//        pause: 1,
//        // ie 7/8 bug
//        cleartypeNoBg: true
//      });
//      $('.slides-outer-navfooter').swipe(NavigationFooter.mobileAgentSwipeSlides);
//      $('.slides-outer-navfooter').cycle('pause');
//      $('.slides-nav-navfooter a, .slides_next-navfooter, .slides_prev-navfooter').click(function () { $('.slides-outer-navfooter').cycle('pause'); });
//    }
//  }
//};

//NavigationFooter.initiateCarousel = function ()
//{
//  if ($(".NavigationFooter .agentListing").children().length > 1)
//  {
//    if ($(window).width() < 992)
//    {
//      NavigationFooter.initiateCarouselSwipe();
//    }
//    else
//    {
//      NavigationFooter.agentCarousel('footerNav');
//    }
//    if ((typeof Global !== 'undefined') && (typeof Global.AddResizeEvent === "function"))
//    {
//      Global.AddResizeEvent(function ()
//      {
//        $('.NavigationFooter .agentListing').attr('style', '');
//        if ($(window).width() < 992)
//        {
//          NavigationFooter.initiateCarouselSwipe();
//        }
//        else
//        {
//          $('.agent-nav').html('');
//          $('.NavigationFooter .slides-inner-navfooter').attr('style', '');
//          $('.NavigationFooter .agentListing').attr('style', '');
//          NavigationFooter.agentCarousel('footerNav');
//        }
//      });
//    }
//  }

//  NavigationFooter.setNavigationText();
//};

//NavigationFooter.setNavigationText = function () {
//  if (typeof myNavPrev != "undefined") {
//    $('.pagination-nav .pgPrev').children('a').html(myNavPrev);
//  }
//  if (typeof myNavNext != "undefined") {
//    $('.pagination-nav .pgNext').children('a').html(myNavNext);
//  }
//};

//NavigationFooter.setIconWidth = function ()
//{
//  if (($(window).width() >= 768) && ($(window).width() < 992))
//  {
//    $(".NavigationFooter .agentContactIconsBottom").each(function ()
//    {
//      var iconCount = $(this).find("li").length - 1;

//      if (iconCount <= 1)
//      {
//        $(this).find("a").css("padding", "9px 131px");
//      }
//      else if (iconCount === 2)
//      {
//        $(this).find("a").css("padding", "9px 56px");
//      }
//      else if (iconCount === 3)
//      {
//        $(this).find("a").css("padding", "9px 32px");
//      }
//      else if (iconCount === 4)
//      {
//        $(this).find("a").css("padding", "9px 19px");
//      }
//      else if (iconCount === 5)
//      {
//        $(this).find("a").css("padding", "9px 11px");
//      }
//    });
//  }
//  else
//  {
//    $(".NavigationFooter .agentContactIconsBottom li a").each(function ()
//    {
//      $(this).removeAttr("style");
//    });
//  }
//}

NavigationFooter.getReviewDiv = function (agentNumber, reviewText, reviewEnding)
{
  if ($('.reviews-' + agentNumber).length !== 0)
  {
    $('.nfAgentStars-' + agentNumber).empty();
    $('.nfAgentStars-' + agentNumber).append($('.reviews-' + agentNumber).clone().wrap('<div>').parent().html());

    if ($('.nfAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .count')[0].innerHTML !== "1")
    {
      reviewText += reviewEnding;
    }

    $('.nfAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .reviewText').html(reviewText);
  }
}

$(window).ready(function ()
{
  if ($(".NavigationFooter .quoteCTA .quoteType").length > 0)
  {
    //Select Placeholder option from the Quote Product drop down by default
    $(".NavigationFooter .quoteCTA .quoteType").css('color', '#4d4d4d');
    $(".NavigationFooter .quoteCTA .quoteType").on('change', function ()
    {
      if (this.value == "SelAProd")
      {
          $(".NavigationFooter .quoteCTA .quoteType").css('color', '#4d4d4d');
      } else
      {
        $(".NavigationFooter .quoteCTA .quoteType").css('color', '#4d4d4d');
        $(".NavigationFooter .quoteCTA .quoteType .notDisabled").css('color', '#4d4d4d');
      }
    });

    $('iframe[src^="javascript:void(0)"]').attr('title', "analytics iframe");
    $('iframe[id^="kaltura_player"]').removeAttr('aria-describedby').removeAttr('aria-labelledby').removeAttr('scrolling').removeAttr('frameborder').attr('title', "video player");
  }

  //$(window).on('resize', function ()
  //{
  //  if (this.resizeTO)
  //  {
  //    clearTimeout(this.resizeTO);
  //  }

  //  this.resizeTO = setTimeout(function ()
  //  {
  //    NavigationFooter.setIconWidth();
  //  }, 250);
  //});
});

/***** End Navigation Footer Component Scripts *****/

/***** Begin Global Navigation Scripts ***/
var GlobalNavigation = {};//new Object();

GlobalNavigation.initialHeight = 0;
GlobalNavigation.initialHeight3and6 = 100;
GlobalNavigation.initialHeight9and12 = 96;
GlobalNavigation.isTopHatExpanded = false;
GlobalNavigation.searchType = "";
GlobalNavigation.defaultSearchResults = "";
GlobalNavigation.searchText = "";
GlobalNavigation.searchRequest = null;
GlobalNavigation.searchTimeout = null;

GlobalNavigation.Initialize = function ()
{
  $(".LayoutHeader").css("float", "none");
  GlobalNavigation.initialHeight = $(".GlobalNavigation").height();

  // mobile
  $(window).on("orientationchange", function ()
  {    
    $(".GlobalNavigation .top-navigation").trigger("click");
    GlobalNavigation.closeNav();
    //GlobalNavigation.setMobileNavHeight();
    if (window.innerWidth < 992) {
        GlobalNavigation.initialHeight = GlobalNavigation.initialHeight3and6;
    } else {
        GlobalNavigation.initialHeight = GlobalNavigation.initialHeight9and12;
    }
    $(".GlobalNavigation").stop().animate({
        height: GlobalNavigation.initialHeight + "px"
    });
    if ($(".inner-wrapper").css("left") != "-300px") {
        $(".inner-wrapper").animate({ "left": "-300px" });
        $("#bodyContainer").animate({ "left": "0px" });
        $("#bannerRow").animate({ "left": "0px" });
        $("#footerRow").animate({ "left": "0px" });
    }
  });

  // mobile open 
  $(".GlobalNavigation .top-navigation").on("click", ".mobile-navbar", function ()
  {
      $(".GlobalNavigation .inner-wrapper").animate({ "left": "0px" });
      if (window.innerWidth < 992) {
          $(".GlobalNavigation .inner-wrapper").css("height", window.innerHeight);
      }
      else
      {
          $(".GlobalNavigation .inner-wrapper").css("height", "3741px");
      }
    $(".GlobalNavigation .mobile-gradient").show();
    Global.BackToTop();
    $(".GlobalNavigation .top-navigation").trigger("click");
  });

  // mobile close
  $(".GlobalNavigation .top-navigation").on("click", ".subheader-close", function (e)
  {    
    e.preventDefault();
    GlobalNavigation.closeNav();
  });

  // nav link or button clicked
  $(".GlobalNavigation .inner-wrapper .nav-parent").on("click", "> a, > button", function (e)
  {
    GlobalNavigation.UnbindScrollFunction();
    e.preventDefault();
    var obj = $(this).parent();
    GlobalNavigation.toggleNav(obj);
    GlobalNavigation.BindScrollFunction();
    if (window.innerWidth < 992) {
        $(".inner-wrapper").height(window.innerHeight);
        $('.inner-wrapper').css({
            'overflow-x': 'auto',
            'position': 'fixed'
        });
    }
  });

  // toggle insurance secondary nav
  $(".GlobalNavigation .inner-wrapper .nav-parent-secondary").on("click", "> a", function (e)
  {
    GlobalNavigation.UnbindScrollFunction();
    e.preventDefault();
    GlobalNavigation.toggleSecondary();
    GlobalNavigation.BindScrollFunction();
    if (window.innerWidth < 992) {
        $(".inner-wrapper").height(window.innerHeight);
        $('.inner-wrapper').css({
            'overflow-x': 'auto',
            'position': 'fixed'
        });
    }
  });


  $('.GlobalNavigation .tophat').click(function (e)
  {
    e.preventDefault();
    if (GlobalNavigation.ToggleTopHat != undefined)
    {
      GlobalNavigation.ToggleTopHat();
    }
    else
    {
      Global.ToggleTopHat();
    }
  });
  $('#tophatclose').click(function (e)
  {
    e.preventDefault();
    GlobalNavigation.CollapseTopHat();
  });
  
  GlobalNavigation.BindScrollFunction();

  if (document.addEventListener)
  {
    $(window).click(function (e)
    {
      if ($(e.target).parents('.tophat').length == 0 && $(e.target).parents('.tophatcontainer').length == 0 && $(e.target).parents('.IconTopNavigation').length == 0 && $(e.target).parents('.modalContentZip').length == 0 && !$(e.target).hasClass('btnSave') && !$('.modalZipCode').hasClass('modalOpen'))
      {
        if (GlobalNavigation.isTopHatExpanded)
        {
          GlobalNavigation.CollapseTopHat();
        }
      };
      if (Global.isInitialLoadClick)
      {
        Global.isInitialLoadClick = false;
      } else
      {
        if ($(e.target).parents('.nav-parent').length == 0)
        {;
          GlobalNavigation.closeQuoteMyAccount();
        }
      }
    });
  } else
  {
    $('body').click(function (e)
    {
      if ($(e.target).parents('.tophat').length == 0 && $(e.target).parents('.tophatcontainer').length == 0 && $(e.target).parents('.IconTopNavigation').length == 0 && $(e.target).parents('.modalContentZip').length == 0 && !$(e.target).hasClass('btnSave') && !$('.modalZipCode').hasClass('modalOpen'))
      {
        if (Global.isTopHatExpanded)
        {
          Global.CollapseTopHat();
        }
      };
      if (Global.isInitialLoadClick)
      {
        Global.isInitialLoadClick = false;
      } else
      {
        if ($(e.target).parents('.nav-parent').length == 0)
        {;
          GlobalNavigation.closeQuoteMyAccount();
        }
      }
    });
  }

  $(window).on("load", function()
  {
    GlobalNavigation.EnableSlideNavigation();
  });

  GlobalNavigation.setMobileNavHeight();
    //if ((typeof Global !== 'undefined') && (typeof Global.AddResizeEvent === "function"))
    //{ 
  $(window).resize(function () {
         if (window.innerWidth < 992) {         
               $(".inner-wrapper").height(window.innerHeight);
              $(".inner-wrapper").css({
                  'overflow-x': 'auto',
                  'position': 'fixed',
                  'height': window.innerHeight
              });
           
          $(".GlobalNavigation").stop().animate({
              height: GlobalNavigation.initialHeight3and6 + "px"
          });
          $('.GlobalNavigation').closest(".pageSection").next().height(GlobalNavigation.initialHeight3and6 + "px");
      }
          else
      {        
          $(".inner-wrapper").height(0);
          $(".GlobalNavigation").stop().animate({
              height: GlobalNavigation.initialHeight9and12 + "px"
          });
          $('.GlobalNavigation').closest(".pageSection").next().height(GlobalNavigation.initialHeight9and12 + "px");
                  
          if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true ))   // If Internet Explorer
          {
              document.getElementsByClassName('inner-wrapper')[0].style.overflowX = "visible";
              document.getElementsByClassName('inner-wrapper')[0].style.position = "static";
             
          }
          else  
          {
              $(".inner-wrapper").css({
                  'left': '-300px',
                  'position': 'static',
                  'overflow-x': 'unset'
              });
          }
         
         
      } 
      //GlobalNavigation.toggleNav();      
  });
    //}
  $(window).resize(function () {   
      GlobalNavigation.setMobileNavHeight();
  });

  if (GlobalNavigation.searchType === "rtd")
  {
    var data = JSON.parse(GlobalNavigation.defaultSearchResults);
    GlobalNavigation.PopulateSearchLinks(data, true);
  }
};

GlobalNavigation.HideSearchResults = function()
{
  $(".searchResultsDropdown").css("display", "none");
};

GlobalNavigation.callSearchAjax = function(reset)
{

  var data = $('form').serializeArray();
  data.push({ name: 'Method', value: 'SmartSearchText' });
  data.push({ name: 'SmartSearchPageId', value: $("#smartSearchPageId").val() });

  data.push({ name: 'SmartSearchText', value: GlobalNavigation.searchText });

  GlobalNavigation.searchRequest = $.ajax({
    type: "POST",
    url: "/anon/handlers/ajaxactivity.ashx",
    dataType: "json",
    data: data,
    crossDomain: true,
    timeout: 5000,
    headers: null
  })
    .done(function (data)
    {
      GlobalNavigation.PopulateSearchLinks(data, reset);
    })
    .fail(function (data)
    {
      data = JSON.parse(GlobalNavigation.defaultResults);
      GlobalNavigation.PopulateSearchLinks(data, true);

      if (!reset)
      {
      }
    })
    .always(function (data)
    {
        $(".searchResultsDropdown").css("display", "inline-block");
    });
};

GlobalNavigation.PopulateSearchLinks = function (data, reset)
{
  var items = [];

  data.offers.sort(function (a, b) { return parseFloat(a.rank) - parseFloat(b.rank); });

  $.each(data.offers, function (id, link) {
    if ((reset && (id >= 5)) || (!reset && (id >= 3)))
    {
      return false;
    }
    
    items.push('<li><a href="' + link.url + '" onclick="GlobalNavigation.SendLearning(\'' + data.searchId + '\', \'' + link.choiceId + '\', \'' + data.inputString + '\')">' + link.title + '</a></li>');
  });

  if (reset)
  {
    $(".searchResultsDropdown .popularSearchResults").html(items.join(''));
  }
  else
  {
    $(".searchResultsDropdown .searchResults").html(items.join(''));
  }
};


GlobalNavigation.SendLearning = function (searchId, choice, searchText)
{
  var data = $('form').serializeArray();
  data.push({ name: 'Method', value: 'SmartSearchLearning' });
  data.push({ name: 'SearchId', value: '' + searchId + '' });
  data.push({ name: 'ChoiceId', value: '' + choice + '' });
  data.push({ name: 'SmartSearchText', value: '' + searchText + '' });
  data.push({ name: 'SmartSearchPageId', value: $("#smartSearchPageId").val() });

  GlobalNavigation.searchRequest = $.ajax({
    type: "POST",
    url: "/anon/handlers/ajaxactivity.ashx",
    dataType: "json",
    data: data,
    crossDomain: true,
    timeout: 5000,
    headers: null
  })
    .done(function (data) {
    })
    .fail(function (data) {
    })
    .always(function (data) {
    });
};

GlobalNavigation.BindScrollFunction = function()
{
  setTimeout(function(){$(window).bind("scroll.GlobalNavigationScroll", function()
  {
    if (GlobalNavigation.isTopHatExpanded)
    {
      GlobalNavigation.CollapseTopHat();
    }

    if (window.innerWidth >= 992)
    {
      GlobalNavigation.closeQuoteMyAccount();
    }
  });}, 500);
}

GlobalNavigation.UnbindScrollFunction = function()
{
  $(window).unbind(".GlobalNavigationScroll");
}

// This function toggles the Top Hat section of the Responsive Top Navigation component to open or close.
GlobalNavigation.ToggleTopHat = function()
{
  if (GlobalNavigation.isTopHatExpanded)
  {
    GlobalNavigation.CollapseTopHat();
  }
  else
  {
    GlobalNavigation.ExpandTopHat();
    try {
      ProcessMetrics('OpenExplore');
    } catch (ex) { }    
  }
}

// This function expands the Top Hat section of the Responsive Top Navigation component.
GlobalNavigation.ExpandTopHat = function ()
{
  if (!GlobalNavigation.isTopHatExpanded)
  {
    $('#TopHatContainer').show();

    //GlobalNavigation.CollapseTopNavigation();

    GlobalNavigation.isTopHatExpanded = true;
  }

  $('.tophatExplore').addClass('expanded');
}

// This function collapses the Top Hat section of the Responsive Top Navigation component.
GlobalNavigation.CollapseTopHat = function ()
{
  if (GlobalNavigation.isTopHatExpanded)
  {
    $('#TopHatContainer').hide();

    GlobalNavigation.isTopHatExpanded = false;
  }

  $('.tophatExplore').removeClass('expanded');
}

GlobalNavigation.setMobileNavHeight = function ()
{
  $(document).ready(function ()
  {
    if (window.innerWidth < 992)
    {
        $(".inner-wrapper").height(window.innerHeight);
      GlobalNavigation.initialHeight = GlobalNavigation.initialHeight3and6;
    } else {
      //$(".GlobalNavigation .inner-wrapper").css("height", "0");
      $(".inner-wrapper").height(0);
      GlobalNavigation.initialHeight = GlobalNavigation.initialHeight9and12;
       
    }
    $(".GlobalNavigation").stop().animate({
        height: GlobalNavigation.initialHeight + "px"
    });
   
  });

  $(document).ajaxStop(function ()
  {
    if (window.innerWidth < 992)
    {
       
        $(".inner-wrapper").height($(document).height());
        
    }
  });
}


GlobalNavigation.noPostBack = function (buttonName, evt)
{
  if (window.event)
  {
    skeyCode = event.keyCode;
  }
  else
  {
    skeyCode = evt.which;
  }

  if (skeyCode == 13)
  {
    if (buttonName == "Imagebutton2")
    {
      GlobalNavigation.searchSubmit('Imagebutton2', evt);
    }
    else if (buttonName == "mobile_Imagebutton2")
    {
      GlobalNavigation.searchSubmit('mobile_Imagebutton2', evt);
    }

    return false;
  }
  else
  {
    if (buttonName == "Imagebutton2")
    {
      if ($("#s_Text").val() !== "")
      {
        GlobalNavigation.searchText = $("#s_Text").val();
        $("#mobile_s_Text").val($("#s_Text").val());
      }
    }
    else if (buttonName == "mobile_Imagebutton2")
    {
      if ($("#mobile_s_Text").val() !== "")
      {
        GlobalNavigation.searchText = $("#mobile_s_Text").val();
        $("#s_Text").val($("#mobile_s_Text").val());
      }
    }

    if ($("#mobile_s_Text").val() !== "")
    {
        $("#mobile-search-clear").css("display", "block");
    }
    else
    {
        $("#mobile-search-clear").css("display", "none");
    }

    if ((GlobalNavigation.searchType === "rtd") && (GlobalNavigation.searchText !== ""))
    {
      if (GlobalNavigation.searchRequest && GlobalNavigation.searchRequest.readyState != 4)
      {
        GlobalNavigation.searchRequest.abort();
      }

      window.clearTimeout(GlobalNavigation.searchTimeout);
      GlobalNavigation.searchTimeout = window.setTimeout(GlobalNavigation.callSearchAjax, 250);
    }
  }
}

GlobalNavigation.openQuoteKey = function (e)
{
  var code = e.keyCode || e.which;

  if (code == 13)
  {
    $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-quote .btn-quote:first").trigger("click");
  }
}

GlobalNavigation.skipNavigation = function (e) {
    debugger;
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode === 13) {
        window.location.href = "#heroBannerInner"
    }
}
GlobalNavigation.openMyAccountKey = function (e)
{
  var code = e.keyCode || e.which;

  if (code === 13)
  {
    $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-account .btn-account-login-alt").trigger("click");
    setTimeout(function () { $(".login-box input:first").focus(); }, 1000);
    }

  if (code === 32) {
        $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-account .btn-account-login-alt").trigger("click");
        $(".login-box input:first").focus();
    }
}
GlobalNavigation.MyAccountLogin = function (e) {
    var code = e.keyCode || e.which;

    if (code == 13) {

        $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-account .login-box .openLoginModal").trigger("click")
    }
}
GlobalNavigation.openMyAccountKeyLogoutView = function (e)
{
  var code = e.keyCode || e.which;

  if (code === 13)
  {
    $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-account .btn-account-login").trigger("click");
    setTimeout(function () { $(".login-box input:first").focus(); }, 1000);
    }

    if (code === 32) {
        $(".GlobalNavigation .IconTopNavigation .inner-wrapper .nav-account .btn-account-login").trigger("click");
        $(".login-box input:first").focus();
    }
}
GlobalNavigation.searchSubmit = function (buttonName, evt)
{
  if (((document.forms[0].s_Text != undefined) && (document.forms[0].s_Text.value != "")) || ((document.forms[0].mobile_s_Text != undefined) && (document.forms[0].mobile_s_Text.value != "")))
  {
    var searchURL = document.forms[0].s_URL.value;
    var spA = document.forms[0].sp_a.value;
    var spP = document.forms[0].sp_p.value;
    var spT = document.forms[0].sp_t.value;
    var spQ;

    if (buttonName == "Imagebutton2")
    {
      spQ = document.forms[0].sp_q.value;
    }
    else if (buttonName == "mobile_Imagebutton2")
    {
      spQ = document.forms[0].mobile_sp_q.value;
    }

    document.forms[0].action = searchURL + "?q=" + spQ;
    document.location.href = searchURL + "?q=" + spQ;

    ProcessMetrics('EnterpriseSearch', [spQ]);

    document.forms[0].submit;

    return true;
  }

  return false;
}

GlobalNavigation.closeQuoteMyAccount = function ()
{
    if (window.innerWidth < 992) {
        GlobalNavigation.initialHeight = GlobalNavigation.initialHeight3and6;
    } else {
        GlobalNavigation.initialHeight = GlobalNavigation.initialHeight9and12;
    }

    //alert(GlobalNavigation.initialHeight);
    var exp = $(".GlobalNavigation .inner-wrapper .nav-parent.expanded");

    exp.children(".GlobalNavigation .nav-child").slideUp(function () {
      exp.removeClass("expanded");
      var props = {};
      props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
      globalEvents.Event('topNavExpand').publish(props);
    });

    $(".GlobalNavigation .nav-parent.expanded").removeClass("expanded");

    $(".GlobalNavigation").stop().animate({
        height: GlobalNavigation.initialHeight + "px"
    });    
}

GlobalNavigation.closeNav = function ()
{
  GlobalNavigation.toggleNav();
  $(".inner-wrapper").animate({ "left": "-300px" });
  $(".mobile-gradient").delay(400).hide(0);
}

GlobalNavigation.toggleNav = function (obj)
{
  if (window.innerWidth < 992) {
      GlobalNavigation.initialHeight = GlobalNavigation.initialHeight3and6;
  } else {
      GlobalNavigation.initialHeight = GlobalNavigation.initialHeight9and12;
  }

  var childHeight = 0;
  if (typeof obj != "undefined") {
    childHeight = obj.find(".nav-child").height();
  }
  // close insurance secondary nav if open
  if ($(".GlobalNavigation .nav-parent-secondary").hasClass("expanded"))
  {
    GlobalNavigation.toggleSecondary();
  }

  var exp = $(".GlobalNavigation .inner-wrapper .nav-parent.expanded");
  if (!obj || obj.hasClass("expanded"))
  {
    exp.children(".GlobalNavigation .nav-child").slideUp(function ()
    {
      exp.removeClass("expanded");
      var props = {};
      props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
      globalEvents.Event('topNavExpand').publish(props);
    });
    $(".GlobalNavigation").stop().animate({
        height: GlobalNavigation.initialHeight + "px"
    });
  }
  else if (exp.length)
  {
    exp.children(".GlobalNavigation .nav-child").slideUp(function ()
    {
      exp.removeClass("expanded");
      var props = {};
      props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
      globalEvents.Event('topNavExpand').publish(props);
      obj.addClass("expanded").children(".nav-child").slideDown(function ()
      {
        var props = {};
        props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
        globalEvents.Event('topNavExpand').publish(props);
      });
    });   
    $(".GlobalNavigation").stop().animate({
        height: GlobalNavigation.initialHeight + "px"
    });
    if (obj.find('button.no-expand').length <= 0) {
        if (window.innerWidth >= 992) {
            $(".GlobalNavigation").stop().animate({
                height: GlobalNavigation.initialHeight + childHeight + "px"
            });
        }
    }
  }
  else
  {
    if (obj.find('button.no-expand').length <= 0) {
        if (window.innerWidth >= 992) {
            $(".GlobalNavigation").stop().animate({
                height: GlobalNavigation.initialHeight + childHeight + "px"
            });
        }
    }
    obj.addClass("expanded").children(".nav-child").slideDown(function ()
    {
      var props = {};
      props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
      globalEvents.Event('topNavExpand').publish(props);
    });
  }
}

GlobalNavigation.toggleSecondary = function ()
{
  var obj = $(".GlobalNavigation .nav-parent-secondary");
  if (obj.hasClass("expanded"))
  {
    obj.children(".GlobalNavigation .nav-child-secondary").slideUp(function ()
    {
      obj.removeClass("expanded").children("a").text(Global.More);
      globalEvents.Event('topNavExpand').publish({ 'GlobalNavigation': $('.GlobalNavigation').closest(".pageSection").height() });
    });
    if (window.innerWidth >= 992) {
        $(".GlobalNavigation").animate({
            height: GlobalNavigation.initialHeight + $(".topnavOuter").height() + $(".GlobalNavigation .inner-wrapper .nav-parent.expanded").height() + "px"
        });
    }
  }
  else
  {
    obj.addClass("expanded").children("a").text(Global.Less);
    obj.children(".GlobalNavigation .nav-child-secondary").slideDown(function ()
    {
      var props = {};
      props[$(".GlobalNavigation").closest(".pageSection").attr("id")] = $('.GlobalNavigation').closest(".pageSection").height();
      globalEvents.Event('topNavExpand').publish(props);
    });
    if (window.innerWidth >= 992) {
        $(".GlobalNavigation").animate({
            height: GlobalNavigation.initialHeight + $(".topnavOuter").height() + $(obj).height() + $(obj).children(".GlobalNavigation .nav-child-secondary").height() + "px"
        });
    }
  }
}

GlobalNavigation.SetDefaultNavigation = function ()
{
  if ((typeof gnSelectedIndex != "undefined") && (gnSelectedIndex != null) && (gnSelectedIndex >= 0))
  {
    $('.GlobalNavigation .nav-primary a').eq(gnSelectedIndex).click();
  }
  $('.zipEdit').click(function (e) { e.preventDefault(); });
}

GlobalNavigation.EnableSlideNavigation = function ()
{
  $(document).ready(function ()
  {
    //stick in the fixed 100% height behind the mobileNavbar but don't wrap it
    $('#slide-mobile-navbar.mobile-navbar .container').append($('<div id="mobileNavbar-height-col"></div>'));

    // Enter your ids or classes
    var toggler = '.mobile-navbar';
    var pagewrapper = '#bodyContainer';
    var bannerwrapper = '#bannerRow';
    var footerwrapper = '#footerRow';
    var mobileNavigationwrapper = '.inner-wrapper';
    // the menu inside the slide menu itself
    var menuwidth = '100%';
    var slidewidth = '325px';
    var menuneg = '-100%';
    var slideneg = '-80%';

    $("#slide-mobile-navbar, #subheader-close").on("click", function (e)
    {
      var selected = $(this).hasClass('slide-active');
      $('.inner-wrapper').toggleClass('slide-active').stop().animate({
        left: $('.inner-wrapper').hasClass('slide-active') ? '0px' : menuneg
      });
      //$('#mobileNavbar-height-col').stop().animate({
      //  left: selected ? slideneg : '0px'
      //});
      $(bannerwrapper).toggleClass('slide-active').stop().animate({
        left: $(bannerwrapper).hasClass('slide-active') ? slidewidth : '0px'
      });
      $(pagewrapper).toggleClass('slide-active').stop().animate({
        position: 'relative',
        left: $(pagewrapper).hasClass('slide-active') ? slidewidth : '0px'
      });
      $(footerwrapper).toggleClass('slide-active').stop().animate({
        left: $(footerwrapper).hasClass('slide-active') ? slidewidth : '0px'
      });
      //$(mobileNavigationwrapper).stop().animate({
      //  left: selected ? '0px' : slidewidth
      //});
      //$(this).toggleClass('slide-active', !selected);
      //$('#slidemenu').toggleClass('slide-active');
      //$('#bodyContainer, #bannerRow, #footerRow, .mobile-navbar, body, .mobile-header').toggleClass('slide-active');




      //var isInsuranceOpen = $("#InsuranceAndMore").parent().hasClass('expanded');
      //if (selected)
      //{
      //  if (isInsuranceOpen)
      //  {
      //    $("#InsuranceAndMore").trigger("click");
      //  }
      //} else
      //{
      //  if (isInsuranceOpen == false)
      //  {
      //    $("#InsuranceAndMore").trigger("click");
      //  }
      //}
    });

    //var selected = '#slidemenu, #bannerRow, #bodyContainer, #footerRow, body, .mobile-navbar, .mobile-header';
    //if ((typeof Global !== 'undefined') && (typeof Global.AddResizeEvent === "function"))
    //{
      $(window).resize(function ()
      {
        if (($(window).width() > 992) && $(bannerwrapper).hasClass('slide-active'))
        {
          $("#subheader-close").trigger("click");
          $(".mobile-gradient").css("display", "none");
        }        
      });
    //}
  });
};

/***** End Global Navigation Scripts *****/


/***** Begin Agent Flyout ***/
var AgentFlyout = {};//new Object();

AgentFlyout.checkAgentImages = function ()
{
  for (var i = 0; i < $('.afoAgentListing').find('img.agentPhotoImg').length; i++)
  {
    if (!Global.IsImageOk($('.afoAgentListing').find('img.agentPhotoImg')[i]))
    {
      $($('.afoAgentListing').find('img.agentPhotoImg')[i]).attr('src', '/resources/images/agent-mia.jpg');
    }
  }
}

AgentFlyout.agentCarousel = function (drwNm)
{
  $('#' + drwNm + ' .afoAgentListing').easyPaginate({
    step: 2,
    container: 'afo-agent-nav'
  });
}

AgentFlyout.agentCarouselCustomer = function (drwNm)
{
  $('#' + drwNm + ' .afoAgentListing').easyPaginate({
    step: 1,
    container: 'afo-agent-nav'
  });
}

AgentFlyout.agentInitiateNavigation = function ()
{
    AgentFlyout.agentCarousel('AgentFlyoutContainer');
}

AgentFlyout.GetFiveStars = function (myProducerNumber, reviewDiv)
{
  $('.afoAgentStars-' + myProducerNumber).empty();
  $('.afoAgentStars-' + myProducerNumber).append(reviewDiv);
};

AgentFlyout.setNavigationText = function ()
{
  if (typeof myAFOAgentPrevious != 'undefined')
  {
    $('.AgentFlyout .pagination-nav .pgPrev').children('a').html(myAFOAgentPrevious);
  }
  if (typeof myAFOAgentNext != "undefined")
  {
    $('.AgentFlyout .pagination-nav .pgNext').children('a').html(myAFOAgentNext);
  }
}

AgentFlyout.Initialize = function ()
{
  // agent open
  $(".AgentFlyout .agent-tab").on("click", "a", function (e)
  {
    e.preventDefault();
    var agentTabWidth = $(".agent-tab").outerWidth();
    $(".agent-flyout-inner").show(function () { $(".agent-flyout-inner").animate({ "right": "0px" }), 500 });
    $(".agent-tab").animate({ "right": "-" + agentTabWidth + "px" }, 500, function () { $(".agent-tab").hide() });
  });

  // agent close
  $(".AgentFlyout .agent-flyout-inner").on("click", ".agent-close", function (e)
  {
    e.preventDefault();
    var agentFlyoutWidth = $(".agent-flyout-inner").outerWidth() + $(".agent-close").outerWidth();
    $(".agent-flyout-inner").animate({ "right": "-" + agentFlyoutWidth + "px" }, 500, function () { $(".agent-flyout-inner").hide() });
    $(".agent-tab").show(function () { $(".agent-tab").animate({ "right": "0px" }, 500) });
  });
};

/***** End Agent Flyout ***/

/***** Begin Middle Navigation - Customer ***/
var MiddleNav = {};//new Object();

MiddleNav.Language = "en";
MiddleNav.Paperless = "Go paperless"
MiddleNav.SetupAutoPay = "Set up auto pay";
MiddleNav.PaidInFull = "Your bill is paid in full";
MiddleNav.NextBill = "Your next bill is due";
MiddleNav.PayNow = "Pay now";
MiddleNav.ErrorMessage = "Unable to display billing information at this time.";
MiddleNav.PaymentPastDue = "A payment may be <br/>past due";
MiddleNav.HelpAndSupport = "";
MiddleNav.HelpAndSupportURL = "";
Date.prototype.addDays = function (days)
{
  var myDate = new Date(this.valueOf());
  myDate.setDate(myDate.getDate() + days);
  return myDate;
}

MiddleNav.isValid = function (data)
{
  if (typeof (data.messageStatusCd) == "undefined" ||
      typeof (data.nextPaymentDate) == "undefined" ||
      typeof (data.urlInfo) == "undefined" ||
      typeof (data.indicatorInfo) == "undefined")
  {

    return false;
  }
  if (data.messageStatusCd === "2" ||
      data.messageStatusCd === "10" ||
      data.messageStatusCd === "12" ||
      data.messageStatusCd === "99"
      )
  {

    return false;
  }
  if (data.urlInfo.length === 0 || data.indicatorInfo.length === 0)
  {
    return false;
  }
  return true;
}

MiddleNav.getFormattedDate = function (date)
{
  var months = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];

  var monthsES = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
                "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  var daysES = ["domingo", "lunes", "martes", "miercoles", "jueves", "viernes", "sabado"];

  var formattedDate = "";

  if (MiddleNav.Language == "en") {
      formattedDate = (days[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + date.getDate() + '.');
  } else {
      formattedDate = (daysES[date.getDay()] + ', ' + date.getDate() + ' de ' + monthsES[date.getMonth()] + '.');
  }

  return formattedDate;
}

MiddleNav.displayErrorMsg = function ()
{
  $(".MiddleNavigation .nbbdGetErrorMsg").html(MiddleNav.ErrorMessage);
}

MiddleNav.payNowClick = function (url)
{
  try {
    ProcessMetrics('MidNav', ['Pay now', 'MidNav']);
  } catch (ex) { }    
  window.location.href = url + "&intcid=" + Global.SCPageName + "|MidNav|PayNow";
}

MiddleNav.getDynamicCustomerHtml = function (customerData) {
    var myHtml = "";
    var trackingLinkForHelpSupport = "?intcid=" + Global.SCPageName + "|MidNav|HelpSupport";
    if (MiddleNav.isValid(customerData)) {
        try {
            var nextPaymentDateString = customerData.nextPaymentDate;
            var splitValues = nextPaymentDateString.split(/[^0-9]/);
            var nextPaymentDate = new Date(splitValues[2], splitValues[0] - 1, splitValues[1]);

            var formattedDate = MiddleNav.getFormattedDate(nextPaymentDate);
            var throughText = customerData.throughText;
            var autoPayUrl = "";
            var payNowUrl = "";
            var paperlessUrl = "";
            var paperlessIconDisplay = "false";
            for (i = 0; i < customerData.urlInfo.length; i++) {
                switch (customerData.urlInfo[i].urlType) {
                    case "Auto Pay URL":
                        autoPayUrl = customerData.urlInfo[i].url;
                        break;
                    case "Pay Now URL":
                        payNowUrl = customerData.urlInfo[i].url;
                        break;
                    case "Paperless URL":
                        paperlessUrl = customerData.urlInfo[i].url;
                        break;
                }
            }

            //customer boolean indicator values
            var eBillEligibleInd = false;
            var eBillInd = false;
            var autoPayInd = false;
            var autoPayEligibleInd = false;
            for (i = 0; i < customerData.indicatorInfo.length; i++) {
                switch (customerData.indicatorInfo[i].indicatorAppliesTo) {
                    case "EBillEligibleInd":
                        eBillEligibleInd = customerData.indicatorInfo[i].indicatorValue.toUpperCase() === "TRUE";
                        break;
                    case "EBillInd":
                        eBillInd = customerData.indicatorInfo[i].indicatorValue.toUpperCase() === "TRUE";
                        break;
                    case "AutoPayInd":
                        autoPayInd = customerData.indicatorInfo[i].indicatorValue.toUpperCase() === "TRUE";
                        break;
                    case "AutoPayEligibleInd":
                        autoPayEligibleInd = customerData.indicatorInfo[i].indicatorValue.toUpperCase() === "TRUE";
                        break;                     
                }
            }
            var isPaidInFull = false;
            if ((customerData.nextPaymentDate.length === 0) || nextPaymentDate > new Date().addDays(45) || (customerData.nextPaymentDate === "1/1/0001" && customerData.messageStatusCd === "1"))
            {
                isPaidInFull = true;
            //} else if (new Date(customerData.nextPaymentDate) > new Date().addDays(45)) {
            //    isPaidInFull = true;
            //} else if (customerData.nextPaymentDate === "1/1/0001" &&
            //           customerData.messageStatusCd === "1") {
            //    isPaidInFull = true;
            }
    
            myHtml += "<li class='nextBillDueDate'>";
            if (isPaidInFull) {                
                myHtml += "<div class='nbddLabelFull'><div class='nbddLabelFullInner'>" + MiddleNav.PaidInFull;
                if (!(nextPaymentDateString === "")) {
                    if (nextPaymentDateString === "12/31/9999") {
                        myHtml += ".</div></div>";
                    } else {
                        myHtml += " " + throughText + " " + formattedDate + "</div></div>";
                    }
                }
            }
            else if (nextPaymentDate < new Date() && payNowUrl)
                {
                    myHtml += "<div class='nbddLabelHalf'><div class='nbddLabelHalfInner'> " + MiddleNav.PaymentPastDue +" </div></div>";
                    myHtml += "<input class='nbddButton openLinkModal' type='button' value='" + MiddleNav.PayNow + "'";
                    myHtml += " onclick='MiddleNav.payNowClick(&#39;" + payNowUrl + "&#39;)'/>";
            }
            else if ((nextPaymentDate < new Date()) && !payNowUrl) {
                myHtml += "<div class='nbddLabelFull'><div class='nbddLabelFullInner'>" + (MiddleNav.PaymentPastDue).replace('<br />', '') + "</div> </div>";
            }
            else if (autoPayInd) {
                myHtml += "<div class='nbddLabelFull'><div class='nbddLabelHalfInner'> " + MiddleNav.NextBill + " <br />" + formattedDate + "</div></div>";
            }
            else {
                myHtml += "<div class='nbddLabelHalf'><div class='nbddLabelHalfInner'> " + MiddleNav.NextBill + " <br />" + formattedDate + "</div></div>";
                myHtml += "<input class='nbddButton openLinkModal' type='button' value='" + MiddleNav.PayNow + "'";
                myHtml += " onclick='MiddleNav.payNowClick(&#39;" + payNowUrl + "&#39;)'/>";
            }
                
            if (autoPayEligibleInd) {
                if (!autoPayInd) {
                    if (autoPayUrl.length > 0) {
                        myHtml += "<div class='nbbdAutopay'>";
                        myHtml += "<a name='&amp;lpos=MidNav' class='openLinkModal' href='" + autoPayUrl + "&intcid="  + Global.SCPageName + "|MidNav|AutoPay' target='_top'>";
                        myHtml += MiddleNav.SetupAutoPay;
                        myHtml += "</a>";
                        myHtml += "</div>";
                    }
                }
            }

      if (myHtml != "")
      {
        myHtml += "</li>";
        $(".MiddleNavigation .customerOptions").find('li:first').remove();
        $(".MiddleNavigation .customerBill").removeClass("customerGetBillInfo");
        $(".MiddleNavigation .customerOptions").prepend(myHtml);
      }

      myHtml = "";
      if (eBillEligibleInd)
      {
        if (!eBillInd)
        {
          if (paperlessUrl.length > 0)
          {
              paperlessIconDisplay = "true";
            myHtml += "<li class='paperless'>";
              myHtml += "<a name='&amp;lpos=MidNav' class='navIcon openLinkModal' href='" + paperlessUrl + "&intcid=" + Global.SCPageName + "|MidNav|Paperless' target='_top'>";
              myHtml += "<img alt='Paperless' class='paperless-image' src='/resources/images/Clear.gif'>";
            myHtml += "<figcaption>" + MiddleNav.Paperless + "</figcaption>";
            myHtml += "</a>";
              myHtml += "</li>";
              if (MiddleNav.Language === "en")
              {
                  myHtml += "<li>";
                  myHtml += "<a name='&amp;lpos=MidNav' class='navIcon openLinkModal' href='" + MiddleNav.HelpAndSupportURL + trackingLinkForHelpSupport + "' target='_top'>";
                  myHtml += "<img alt='Help Support' class='helpsupport-image' src='/resources/images/Clear.gif'>";
                  myHtml += "<figcaption>" + MiddleNav.HelpAndSupport + "</figcaption>";
                  myHtml += "</a>";
                  myHtml += "</li>";
              }
              
          }
        }
            }

            if (paperlessIconDisplay === "false" && MiddleNav.Language ==="en")
            {
                myHtml += "<li>";
                myHtml += "<a name='&amp;lpos=MidNav' class='navIcon openLinkModal' href='" + MiddleNav.HelpAndSupportURL + trackingLinkForHelpSupport + "' target='_top'>";
                myHtml += "<img alt='Help Support' class='helpsupport-image' src='/resources/images/Clear.gif'>";
                myHtml += "<figcaption>" + MiddleNav.HelpAndSupport + "</figcaption>";
                myHtml += "</a>";
                myHtml += "</li>";
            }
    } catch (ex)
    {
      //console.log(ex);
    }
  } else
  {
        MiddleNav.displayErrorMsg();

        if (MiddleNav.Language === "en") {
            myHtml += "<li class='helpSupport'>";
            myHtml += "<a name='&amp;lpos=MidNav' class='navIcon openLinkModal' href='" + MiddleNav.HelpAndSupportURL + trackingLinkForHelpSupport + "' target='_top'>";
            myHtml += "<img alt='Help Support' class='helpsupport-image' src='/resources/images/Clear.gif'>";
            myHtml += "<figcaption>" + MiddleNav.HelpAndSupport + "</figcaption>";
            myHtml += "</a>";
            myHtml += "</li>";
        }
  }

  if (myHtml != "")
  {
    myHtml += "</li>";
    $(".MiddleNavigation .customerOptions").append(myHtml);
  }
}

MiddleNav.getCustomerInformation = function ()
{
  $.ajax({
    type: "GET",
    url: "/anon/handlers/ajaxactivity.ashx?Method=PaymentInformation",
    dataType: "json",
    success: function (data)
    {
      MiddleNav.getDynamicCustomerHtml(data);
    },
    error: function (request, status, error)
    {
      //console.log("ERROR IN getCustomerInformation CALL: " + status + ", " + error);
        MiddleNav.displayErrorMsg();
    }
  });
}

/***** End End Middle Navigation ***/

/*!
//# sourceMappingURL=Components.min.js.map
*/
